/**
 * Remembered email
 *
 * @package EBNewsletters
 */

const KEY = 'eb-newsletters';
const TTL = 90 * 24 * 60 * 60 * 1000;

const read = () => {
	try {
		const saved = JSON.parse(localStorage.getItem(KEY));
		return saved && Date.now() - saved.at < TTL ? saved : null;
	} catch {
		return null;
	}
};

export const getEmail = () => {
	const fromUrl = new URLSearchParams(location.search).get('email');
	if (fromUrl) {
		saveEmail(fromUrl);
		return fromUrl;
	}

	return read()?.email || '';
};

export const saveEmail = email => {
	try {
		localStorage.setItem(KEY, JSON.stringify({ email, at: Date.now() }));
	} catch {
		// Private mode: the flow still works, it just forgets.
	}
};
